<template>
  <b-container fluid id="tableId">
    <b-row>
      <b-col xs="12" md="12" lg="12" xl="12">
        <h5 class="mb-0">{{ $t("Фойда хисоботи")}}</h5>
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Вақт") }} 1</label>
        <input class="form-control" type="date" v-model="datas.date1" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Вақт") }} 2</label>
        <input class="form-control" type="date" v-model="datas.date2" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label>Склад</label>
        <v-select
          class="form-control-sm md-input"
          :options="skladlist"
          :disabled="skladhave"
          :clearable="false"
          v-model="datas.sklad_id"
          :reduce="name => name.id"
          label="name"
        >
          <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  aria-activedescendant="null"
                />
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
        </v-select>
      </b-col>
      <b-col lg="2" class="my-1">
        <label>Группа</label>
        <v-select
          class="form-control-sm md-input"
          :options="folderlist"
          :clearable="true"
          v-model="datas.product_id"
          :reduce="extra_name => extra_name.id"
          label="extra_name"
        >
        </v-select>
      </b-col>
      <b-col lg="2" class="my-1">
        <label>{{$t('Фойдаланувчи')}}</label>
        <v-select
          class="form-control-sm md-input"
          :options="userlist"
          :clearable="true"
          v-model="datas.user_id"
          :reduce="username => username.id"
          label="username"
        >
        </v-select>
      </b-col>
      <b-col lg="2" class="my-1">
        <br />
        <button type="button" class="btn mybtn" @click="Send()">
          {{ $t("Кўриш") }}
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
        <button type="button" class="btn mybtn" @click="downloadExl('foyda-xisobot',wscols)">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
      </b-col>
      <md-card>
        <md-card-content>
          <CloudSyncButton v-if="inSync==true" style="width: 100%;" :title="syncProgress+'%'" :titleDone="syncProgress+'%'" :syncProgress="syncProgress" :inSync="inSync" :styling="{loadColor: '#81d427',strokeColor: '#fff',btnColor: '#aaa'}"/>
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th class="column1">#</th>
                <th style="width: 35%!important;">{{ $t("Номи") }}</th>
                <th class="column2">{{ $t("Cони") }}</th>
                <th class="column3">{{ $t("Сотиш сумма") }}</th>
                <th class="column3">{{ $t("Тан нарх") }}</th>
                <th class="column1">{{ $t("Фоиз") }}</th>
                <th class="column3">{{ $t("Фойда") }}</th>
              </tr>
            </thead>
            <tbody style="overflow: hidden;">
              <VueAutoVirtualScrollList
                :totalHeight="totalheight"
                :defaultHeight="defaultHeight"
                style="width: 100%!important;height: 60vh;"
              >
                <tr
                  :style="{ height: `${index / 1000 + 20}px` }"
                  class="row100 body"
                  v-for="(item, index) in results"
                  :key="index"
                  @click="RouteSverka(item)"
                >
                  <td class="column1">
                    {{ index + 1 }}
                  </td>
                  <td style="width: 35%!important;">
                    <button
                      type="button"
                      class="noborder"
                      v-if="item.product"
                    >
                      {{ item.product.extra_name }}
                    </button>
                  </td>
                  <td class="column2 kol">
                    <button
                      type="button"
                      class="noborder"
                    >
                      {{ item.balance | numFormats }}
                    </button>
                  </td>
                  <td class="column3 kol">
                    <button
                      type="button"
                      class="noborder"
                    >
                      {{ item.total_sold_summa | numFormats }}
                    </button>
                  </td>
                  <td class="column3 kol">
                    <button
                      type="button"
                      class="noborder"
                    >
                      {{ item.total_body_summa | numFormats }}
                    </button>
                  </td>
                  <td class="column1 kol">
                    <button
                      type="button"
                      class="noborder"
                      v-if="item.total_profit_percent!=null"
                    >
                      {{ parseFloat(item.total_profit_percent).toFixed(0) }}
                    </button>
                    <span v-else>
                      0
                    </span>
                  </td>
                  <td class="column3 kol">
                    <button
                      type="button"
                      class="noborder"
                    >
                      {{ item.total_profit_summa | numFormats }}
                    </button>
                  </td>
                </tr>
              </VueAutoVirtualScrollList>
            </tbody>
            <thead>
              <tr style="background: #aaa;">
                <td colspan="2">{{ $t("Жами") }}</td>
                <td class="column2 kol">{{ summ.kol | numFormats }}</td>
                <td class="column3 kol">{{ summ.sold | numFormats }}</td>
                <td class="column3 kol">{{ summ.body | numFormats }}</td>
                <td class="column1 kol">
                  <span v-if="summ.profit!=0">
                  {{ parseFloat((summ.profit / summ.body) * 100).toFixed(0) }}
                  </span>
                </td>
                <td class="column3 kol">{{ summ.profit | numFormats }}</td>
              </tr>
            </thead>
          </table>
        </md-card-content>
      </md-card>
    </b-row>

    <product :datas="datas"></product>
    <sklad :datas="datas"></sklad>
    <unit></unit>
    <model></model>
    <brand></brand>
    <colour></colour>
  </b-container>
</template>
<script>
import { Product, Unit, Model, Brand, Colour, Sklad } from "@/pages";
import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
import { print } from "../../../components/mixins/print.js";
import CloudSyncButton from "@vuesence/cloud-sync-button";
export default {
  components: {
    Product,
    CloudSyncButton,
    Unit,
    Model,
    Brand,
    Colour,
    Sklad,
    VueAutoVirtualScrollList
  },
  mixins: [print],
  data() {
    return {
      wscols:[{ width: 5 }, { width: 28 }, { width: 13 }, { width: 15 }, { width: 15 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }],
      datas: {
        date1: new Date().toISOString().slice(0, 8) + "01",
        date2: new Date().toISOString().slice(0, 10),
        product_id: null,
        user_id:parseInt(localStorage.getItem("user_id")),
        sklad_id: parseInt(localStorage.getItem("sklad_id"))
      },
      folderlist:[],
      summ: { kol: 0, sold: 0, profit: 0, body: 0 },
      product: "",
      sklad: "",
      skladlist: [],
      userlist:[],
      results: []
    };
  },
  created() {
    let self = this;
    self.Folderlist();
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    self.Userlist();
  },
  methods: {
    Userlist(){
      let self = this;
      axios
        .get("api/v1/users/usernames/"+self.datas.sklad_id)
        .then(function(response) {
          self.userlist = response.data;
        });
    },
    Folderlist() {
      let self = this;
        axios.get("api/v1/product/folder-list").then(function(response) {
          self.folderlist = response.data;
        });
    },
    Jami() {
      let self = this;
      self.summ = { kol: 0, sold: 0, profit: 0, body: 0 };
      self.results.forEach(function(key, value) {
        self.summ.kol += parseFloat(key.balance);
        self.summ.sold += parseFloat(key.total_sold_summa);
        self.summ.profit += parseFloat(key.total_profit_summa);
        self.summ.body += parseFloat(key.total_body_summa);
      });
    },
    Clicked(id) {
      localStorage.setItem("date1", this.datas.date1);
      localStorage.setItem("date2", this.datas.date2);
      localStorage.setItem("product_id", id);
      localStorage.setItem("sklad_id", this.datas.sklad_id);
      this.$router.push({ path: "/xisobot/sverka/foyda" });
    },
    Send() {
      let self = this;
      self.startSync();
      var datas = {
        datetime1: parseInt(
          new Date(self.datas.date1)
            .valueOf()
            .toString()
            .slice(0, 10)
        ),
        datetime2:
          parseInt(
            new Date(self.datas.date2)
              .valueOf()
              .toString()
              .slice(0, 10)
          ) + 86399,
        sklad_id: self.datas.sklad_id,
        user_id: self.datas.user_id,
        product_id: self.datas.product_id
      };
      axios({
        method: "post",
        url: "api/v1/report/profit",
        data: datas
      }).then(function(response) {
        self.results = response.data;
        self.Jami();
        self.syncProgress=100;
      });
    },
    RouteSverka(item) {
      let SverkaWindow;
      SverkaWindow = window.open(
        '#/xisobot/sverka/foyda/'+item.product.id+'/'+this.datas.sklad_id+'/'+this.datas.date1+'/'+this.datas.date2,
        "_blank",
        "width=1000, height=1000"
      );
    }
  }
};
</script>
<style scoped>
/* td,th{
    font-size: 14px;
  } */
</style>
